import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';
import Share from '@/components/elements/Share';

export interface ShareLayoutProps {
  blok: any;
}

const ShareLayout: FC<ShareLayoutProps> = ({ blok }) => {
  return (
    <Section {...storyblokEditable(blok)}>
      <Container size={'xs'}>
        <Share />
      </Container>
    </Section>
  );
};

export default ShareLayout;
